
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sections",
      function () {
        return require("private-next-pages/sections/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sections"])
      });
    }
  